import { ButtonCommon } from "../../../../../../Layout/styled";
import { convertFixed } from "../../../../../../utils/convertNumber";
import { ContentsReward, RowContents, TextNoDataLiquidity } from "../../styled";
import { RemoveContainer } from "../Both/styled";
import axios from "axios";
import { useWriteContract } from "wagmi";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import LoadingSpin from "../../../../../../components/Common/Loading";

const RemoveItem = ({
  item,
  poolDetail,
  addressX,
  addressY,
  price,
  slippageTolerance,
  bin,
  setLoading,
  loading,
  handleGetDataChart,
  isHide,
}: any) => {
  const [isApproved, setIsApproved] = useState(false);
  const [resultRemove, setResultRemove] = useState<any>({});
  const { writeContractAsync } = useWriteContract();

  const removeLiquidity = async () => {
    setLoading(true);
    try {
      const txParams = {
        address: resultRemove?.address,
        abi: resultRemove?.abi,
        functionName: resultRemove?.functionName,
        args: resultRemove?.args,
      };

      writeContractAsync(txParams)
        .then((hash) => {
          if (hash) {
            toast.success(
              isApproved
                ? "Transaction submitted"
                : "Approval transaction submitted"
            );
            setLoading(false);
            setTimeout(() => {
              handleGetDataChart();
            }, 3000);
          }
        })
        .catch((error: any) => {
          console.error("Transaction error:", error);
          toast.error("User rejected transaction");
          setLoading(false);
        });
    } catch (error: any) {
      console.log(error);
      toast.error(error.message || "Transaction failed");
      setLoading(false);
    }
  };

  const handleGetDataRemove = async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        "https://ap-dev-kibble.netlify.app/api/remove-v22",
        {
          wallet: "0x6Ae327b6bD7808924ce7640fA3b84DF30A3C655D",
          tokenX: addressX,
          tokenY: addressY,
          minBin: 123,
          maxBin: 123,
          lbBinStep: poolDetail?.lbBinStep,
          type: item,
        }
      );
      if (res) {
        setResultRemove(res?.data.ParamTX);
        setIsApproved(res?.data.isApproved);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetDataRemove();
  }, [item]);

  return (
    <RemoveContainer>
      <h2>
        You will remove {poolDetail?.tokenX?.symbol} tokens from bins with
        prices higher than that of the active bin. {poolDetail?.tokenY?.symbol}{" "}
        tokens in the active bin will remain in the pool.
      </h2>
      {isHide ? (
        <ContentsReward>
          <RowContents className="row-between remove">
            <p
              style={{
                marginBottom: "10px",
              }}
            >
              You will receive:
            </p>
            <div className="remove-receive">
              <div
                style={{
                  width: "max-content",
                  margin: "0 auto",
                }}
              >
                <div className="img-token row-center">
                  <img
                    style={{ borderRadius: "50%" }}
                    src={`https://img.lfj.gg/cdn-cgi/image/width=60,height=60/https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists-v2/refs/heads/main/logos/43114/${
                      item === 1 ? addressX : addressY
                    }.png`}
                    alt="img"
                  />
                </div>
                <p>{convertFixed(price)}</p>
              </div>
            </div>
          </RowContents>
          <RowContents className="row-between">
            <p>Price Range</p>
            <div className="row-right">
              <p>
                {item === 1 ? (
                  <>
                    {convertFixed(bin[0]?.price)} -{" "}
                    {convertFixed(
                      bin[
                        Math.abs(bin?.length - 1) -
                          Math.abs((bin?.length - 1) / 2)
                      ]?.price
                    )}
                  </>
                ) : (
                  <>
                    {convertFixed(
                      bin[
                        Math.abs(bin?.length - 1) -
                          Math.abs((bin?.length - 1) / 2) +
                          2
                      ]?.price
                    )}{" "}
                    - {convertFixed(bin[bin?.length - 1]?.price)}
                  </>
                )}{" "}
                {poolDetail?.tokenX.symbol} per {poolDetail?.tokenY.symbol}
              </p>
            </div>
          </RowContents>
          <RowContents className="row-between">
            <p>Amount Slippage Tolerance</p>
            <div className="row-right">
              <p>{slippageTolerance}%</p>
            </div>
          </RowContents>
          <RowContents className="row-between">
            <p>Minimum Expected {poolDetail?.symbol}</p>
            <div className="row-right">
              <p>{convertFixed(price)}</p>
            </div>
          </RowContents>
          <div
            style={{
              display: "flex",
              gap: "10px",
            }}
          >
            {!isApproved ? (
              <ButtonCommon
                disabled={loading}
                onClick={() => {
                  removeLiquidity();
                }}
              >
                {loading ? <LoadingSpin /> : "Approve"}
              </ButtonCommon>
            ) : (
              <ButtonCommon
                disabled={loading}
                onClick={() => {
                  removeLiquidity();
                }}
              >
                {loading ? <LoadingSpin /> : "Remove Liquidity"}
              </ButtonCommon>
            )}
          </div>
        </ContentsReward>
      ) : (
        <TextNoDataLiquidity
          style={{
            minHeight: "225px",
          }}
        >
          You have no liquidity in this range.
        </TextNoDataLiquidity>
      )}
    </RemoveContainer>
  );
};

export default RemoveItem;
